import type { OrderedMap } from '@gonfalon/immutable-shim/immutableShim';

import type { Member } from '#utils/members/records/Member';
import type { GenerateActionType } from '#utils/reduxUtils';

export const saveSelectedMembersAction = (members: OrderedMap<string, Member>) =>
  ({ type: 'selectMember/SELECT_MEMBERS', members }) as const;

export const selectMemberSearchAction = (searchValue: string) =>
  ({ type: 'selectMember/SEARCH', searchValue }) as const;

export const loadSelectedMembersAction = (members: OrderedMap<string, Member>) =>
  ({
    type: 'selectMember/LOADED',
    members,
  }) as const;

const SelectMemberActionCreators = {
  loadSelectedMembersAction,
  saveSelectedMembersAction,
  selectMemberSearchAction,
};

export type SelectMemberAction = GenerateActionType<typeof SelectMemberActionCreators>;
